﻿import {Component} from "@angular/core";
import { ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../services/dataService";

@Component({
    selector: "jax-login",
    templateUrl: "./login.component.html",
})
export class LoginComponent {
    public isInternalVisible = false;
    public isExternalVisible = false;
    public sub: any;
    public isLoggedOut: boolean;

    constructor(private dataService: DataService, private route: ActivatedRoute, private router: Router) {

    }

    public ngOnInit() {
        this.isLoggedOut = false;
        this.sub = this.route.queryParams.subscribe(params => {
            if (params["logout"]) {
                this.isLoggedOut = true;
            }
            if (params["IsLoginSelected"]) {
                this.isInternalVisible = true;
            }
        });
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (currentUser && currentUser.Token) {
            this.router.navigate(["dashboard/mywork"]);
        }
    }

    public setInternalVisible() {
        this.isInternalVisible = !this.isInternalVisible;
        this.isExternalVisible = false;
    }

    public setExternalVisible() {
        this.isExternalVisible = !this.isExternalVisible;
        this.isInternalVisible = false;
    }
}


